export const SET_CART = "SET_CART";

export const setCart = cart => ({
  type: SET_CART,
  cart: cart
});
